// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { IListFormVariant } from '~/utils/interface/variant';

export const schema = (t: TFunction): yup.ObjectSchema<IListFormVariant> => {
  return yup.object().shape({
    listVariant: yup
      .array()
      .test(
        'at-least-one-checked',
        t('common_validate_field_required', { ns: 'common/base' }),
        (list) => !!list?.some((item) => item.isChecked === true)
      )
      .optional(),
  });
};

export const defaultValuesListFormVariant: IListFormVariant = {
  listVariant: [],
};
